// import React, { useEffect, useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import axios from "axios";

// const SmartphoneDeals = () => {
//   const [smartphones, setSmartphones] = useState([]);
//   const [orangeDeals, setOrangeDeals] = useState([]);
  
//     useEffect(() => {
//       const fetchData = async () => {
//         const response = await axios.get(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/risingstar_list"
//         );
//         setSmartphones(response.data.result);
//       };
  
//       fetchData();
//     }, []);

//   // Fetch Orange Cards data (simulate different deals)
//     useEffect(() => {
//       fetch("https://dummyjson.com/products/category/groceries")
//         .then((res) => res.json())
//         .then((data) => {
//           const formatted = data.products.slice(0, 4).map((item) => ({
//             title: item.category.replace(/-/g, " "),
//             heading: item.title.split(" ").slice(0, 2).join(" "),
//             img: item.thumbnail,
//           }));
//           setOrangeDeals(formatted);
//         })
//         .catch((err) => console.error("Error fetching orange deals:", err));
//     }, []);

//   return (
//     <div className="container py-4 bg-white" style={{border:"1px"}}>
//       {/* Header */}
//       <div className="d-flex justify-content-between align-items-center mb-3 bg-white">
//         <h3 className="fw-bold bg-white">Top Deals</h3>
//         <a href="#" className=" text-decoration-none bg-white" style={{color:"#ff7043"}}>
//           View All <i className="bi bi-chevron-right bg-white"></i>
//         </a>
//       </div>

//       {/* Smartphone cards */}
// <div className="smartphone-grid bg-white mb-3">

//   {smartphones.length > 0 ? (
//     <>
//       {smartphones.map((phone, index) => (
//         <div
//           key={index}
//           className="card shadow-sm border-0 top-deals"
//         >
//           <img
//             src={`https://cyberathon.com/multivendor/${phone.rising_star_image}`}
//             className="card-img-top bg-white"
//             alt={phone.product}
//             style={{ height: "200px", objectFit: "cover" }}
//           />
//           <div className="card-body bg-white">
//             <h6 className="fw-semibold bg-white">{phone.product}</h6>
//             <p className="mb-0 fw-bold text-dark bg-white">
//               From {phone.current_price}*
//             </p>
//             <p className="text-muted text-decoration-line-through small mb-0 bg-white">
//               {phone.old_price}
//             </p>
//             <p className="text-success fw-semibold small bg-white">
//               {phone.discount}
//             </p>
//           </div>
//         </div>
//       ))}

//       {/* Extra image-only card */}
//       <div
//         className="card shadow-sm border-0 d-flex align-items-center justify-content-center"
//         style={{ width: "250px", height: "350px" }}
//       >
//         <img
//           src="/img/adversiment1.webp"  
//           alt="Ad banner"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             borderRadius: "5px",
//           }}
//         />
//       </div>
//     </>
//   ) : (
//     <p>Loading smartphones...</p>
//   )}
// </div>


//       {/* Orange Cards Section */}
// {orangeDeals.length > 0 ? (
//   <div className="row g-3 mb-3">
//     {/* Left: Orange Cards */}
//     <div className="col-lg-6 col-md-12">
//       <div className="row g-3">
//         {orangeDeals.map((item, index) => (
//           <div className="col-md-6 col-sm-6 col-6" key={index}>
//   <div className="card orange-card">
//     <div className="card-body">
//       <div className="orange-detail">
//         <p className="mb-1 small">{item.title}</p>
//         <h5 className="fw-bold">{item.heading}</h5>
//         <button className="btn orange-btn btn-light mt-2">Shop Now</button>
//       </div>
//       <img
//         src={item.img}
//         alt={item.heading}
//         className="img-fluid ms-2"
//         style={{
//           width: "80px",
//           height: "80px",
//           objectFit: "contain",
//         }}
//       />
//     </div>
//   </div>
// </div>

//         ))}
//       </div>
//     </div>

//     {/* Right: Image-only Card */}
//     <div className="col-lg-6 col-md-12 d-flex align-items-center justify-content-center">
//       <div
//         className="card shadow-sm border-0 w-100"
//         style={{ height: "280px" }}
//       >
//         <img
//           src="/img/Budget_store_Unrec-1._CB797869872_.jpg"
//           alt="Ad banner"
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             borderRadius: "5px",
//           }}
//         />
//       </div>
//     </div>
//   </div>
// ) : (
//   <p>Loading categories...</p>
// )}



      
//     </div>
//   );
// };

// export default SmartphoneDeals;


import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const SmartphoneDeals = () => {
  const [smartphones, setSmartphones] = useState([]);
  const [orangeDeals, setOrangeDeals] = useState([]);
  const [categoryMap, setCategoryMap] = useState({});
  const [advertisementUser, setAdvertisementUser] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
  const fetchAll = async () => {
    try {
      const prodRes = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );

      if (prodRes.data.status === true || prodRes.data.status === "true") {
        const filtered = prodRes.data.data.filter(
          (item) => item.product_status === "Top Deals" &&
                    item.admin_approval === "approval" &&
                    item.paid_approval === "yes"
        );
        setSmartphones(filtered);
      } else {
        toast.error("Failed to fetch product list!");
      }

    } catch (error) {
      console.error("Error fetching:", error);
      toast.error("Error fetching product list.");
    } finally {
      setLoading(false);   // <-- Important!
    }
  };

  fetchAll();
}, []);


useEffect(() => {
  const fetchAll = async () => {
    try {
      const prodRes = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_create_product"
      );

      if (prodRes.data.status === true || prodRes.data.status === "true") {
        const filtered = prodRes.data.data.filter(
          (item) => item.product_status === "Groceries" &&
                    item.admin_approval === "approval" &&
                    item.paid_approval === "yes"
        );
        setOrangeDeals(filtered);
      } else {
        toast.error("Failed to fetch product list!");
      }

    } catch (error) {
      console.error("Error fetching:", error);
      toast.error("Error fetching product list.");
    } finally {
      setLoading(false);   // <-- Important!
    }
  };

  fetchAll();
}, []);

useEffect(() => {
    fetchCategories();
  }, []);

const fetchCategories = async () => {
    try {
      console.log("=== FETCHING CATEGORIES ===");

      const response = await fetch(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
      );

      const result = await response.json();
      console.log("📂 Categories API Response:", result);

      if (result.status === true || result.status === "true") {
        const map = {};
        result.row.forEach((category) => {
          map[category.category_id] = category.category_name;
        });
        setCategoryMap(map);
        console.log("Category Map Created:", map);
      }
    } catch (err) {
      console.error("❌ Category fetch error:", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Correct API endpoint
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_advertisement"
        );

        if (response.data.status === true) {
          setAdvertisementUser(response.data.data);
        } else {
          toast.error("Failed to fetch advertisements");
        }
      } catch (error) {
        console.error(error);
        toast.error("API Error");
      }
    };

    fetchData();
  }, []);


  // Fetch Orange Cards data
  // useEffect(() => {
  //   fetch("https://dummyjson.com/products/category/groceries")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const formatted = (data.products || []).slice(0, 4).map((item) => ({
  //         title: item.category.replace(/-/g, " "),
  //         heading: item.title.split(" ").slice(0, 2).join(" "),
  //         img: item.thumbnail,
  //       }));
  //       setOrangeDeals(formatted);
  //     })
  //     .catch((err) => {
  //       console.error("Error fetching orange deals:", err);
  //       setOrangeDeals([]);
  //     });
  // }, []);

  return (

    <div className="container-fluid py-4 bg-white px-2">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3 bg-white">
        <h3 className="fw-bold bg-white">Top Deals</h3>
        <Link
            to="/products"
            state={{ categoryId: 1 }} // 🔥 Electronics ID
            className="text-decoration-none"
            style={{ color: "#ff7043" }}
          >
            View All <i className="bi bi-chevron-right"></i>
          </Link>
      </div>

      {/* Error Message */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Smartphone cards */}
      <div className="smartphone-grid bg-white mb-3">
        {loading ? (
          <p>Loading smartphones...</p>
        ) : smartphones && smartphones.length > 0 ? (
          <>
            <section className="arrivals-section">
  <div className="arrivals-wrapper">

    {/* 🔥 THIS IS REQUIRED */}
    <div className="arrivals-grid-layout">

      {smartphones.map((phone, index) => (
        <Link
          key={index}
          to={`/model/${phone.product_id}`}
          style={{ textDecoration: "none" }}
        >
          <div className="arrivals-item-card">

            <div className="arrivals-visual">
              <img
                src={`https://cyberathon.com/multivendor/${phone.multi_image?.[0]}`}
                alt={phone.product_name}
                onError={(e) => (e.target.src = "/img/placeholder.png")}
              />

              {/* <div className="arrivals-new-badge">NEW</div> */}
              {/* <div className="arrivals-fav">♡</div> */}

              <div className="arrivals-add-layer">
                <button className="arrivals-btn-add">QUICK ADD</button>
              </div>
            </div>

            <div className="arrivals-content">
              <h3 className="arrivals-product-title">
                {phone.product_name}
              </h3>

              <div className="arrivals-price-info">
                <span className="arrivals-price-new">
                  ₹{phone.current_price}
                </span>
                <span className="arrivals-price-old">
                  ₹{phone.old_price}
                </span>
              </div>
            </div>

          </div>
        </Link>
      ))}

      {/* {advertisementUser
  .filter((item) => item.id === "5")   // 🔥 filter by ID
  .map((item, index) => (
    <div
      key={index}
      className="card shadow-sm border-0 d-flex align-items-center justify-content-center"
      style={{ width: "200px", height: "350px" }}
    >
      <img
        src={`https://cyberathon.com/multivendor/${item.image}`}
        alt={item.title || "Ad banner"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "5px",
        }}
      />
    </div>
  ))} */}

    </div>
  </div>
</section>

          </>
        ) : (
          <p>No smartphones available</p>
        )}
      </div>

      {/* Orange Cards Section */}
      {orangeDeals && orangeDeals.length > 0 ? (
        <div className="row g-3 mb-3">
          {/* Left: Orange Cards */}
          <div className="col-lg-6 col-md-12">
            <div className="row g-3">
              {orangeDeals.map((item, index) => (
                <div className="col-md-6 col-sm-6 col-6" key={index}>
                  <div className="card orange-card">
                    <div className="card-body">
                      <div className="orange-detail">
                        <p className="mb-1 small">{categoryMap[item.category_id] || "Category"}</p>
                        <h5 className="fw-bold">{item.product_name}</h5>
                        <Link to={`/model/${item.product_id}`} style={{ textDecoration: 'none' }}>
                        <button className="btn orange-btn btn-light mt-2">Shop Now</button>
                        </Link>
                      </div>
                      <img
                        src={`https://cyberathon.com/multivendor/${item.multi_image?.[0]}`}
                        className="card-img-top bg-white"
                        alt={item.product}
                        style={{ height: "80px", width: "80px", objectFit: "contain" }}
                        onError={(e) => (e.target.src = "/img/placeholder.png")}
                       />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image-only Card */}
          <div className="col-lg-6 col-md-12">
  {advertisementUser
    .filter((item) => item.id === "3")   // 🔥 filter by ID (string)
    .map((item, index) => (
      <div
        className="card border-0 mb-0"
        style={{ height: "100%", padding: "17px" }}
        key={index}
      >
        <img
          src={
            item.image
              ? `https://cyberathon.com/multivendor/${item.image}`
              : "/images/no-image.png"
          }
          alt={item.title || "Advertisement"}
          style={{
            width: "100%",
            height: "318px",
            objectFit: "cover",
            borderRadius: "5px",
          }}
        />
      </div>
    ))}
</div>

        </div>
      ) : (
        <p>Loading categories...</p>
      )}
    </div>
    // </div>
  );
};

export default SmartphoneDeals;